import { supabase } from "../supabaseClient";
//*All-Projects
async function getAllProjects() {
	// ! vedashree changes
	let query = supabase.from("Projects").select("*", { count: "exact" }).eq("isPublished", true).eq("isVJ", true);
	// let query = supabase.from('Projects').select('*', { count: 'exact' }).eq('isCompleted', true)
	const { data, error, count } = await query;
	if (data) return { data, count };
	else throw error;
}

async function updateFlagsToProjectTable(obj, projectId) {
	let query = supabase.from("Projects").update(obj).eq("projectId", projectId);
	const { data, error, count } = await query;
	if (data) return { data, count };
	else throw error;
}

async function UpdateUnitInfo(obj, unitId) {
	let query = supabase.from("Inventory").update(obj).eq("unitId", unitId);
	const { data, error, count } = await query;
	if (data) return { data, count };
	else throw error;
}

async function UpdateProjectTnC(obj, projectId) {
	let query = supabase.from("Projects").update(obj).eq("projectId", projectId);
	const { data, error, count } = await query;
	if (data) return { data, count };
	else throw error;
}

async function uploadDigitCostBannerImg(obj, id) {
	// const file = dataURLtoFile(obj, `${id}.webp`);
	console.log("-aadhar-->", obj, id);

	return supabase.storage
		.from("digitalCostSheetImages")
		.upload(`${id}/${obj.name}`, obj, {
			upsert: true,
		})
		.then((res) => {
			if (res.data) {
				console.log("Data uploaded to storage", res);
				supabase
					.from("Projects")
					.update({ bannerImages: res.data.Key })
					.eq("projectId", id)
					.then((labour) => {
						if (labour.data) {
							console.log("images saved for project images");
						} else {
							console.log("Didn't save", labour.error);
						}
					});
			} else {
				console.log("Something went wrong", res.error);
			}
		});
}

async function getUnitDataByProjectId(projectId, wingId, unitNo) {
	const { data, error } = await supabase
		.from("Inventory")
		.select("* , inventoryTypeId(*),wingId(*)")
		.eq("projectId", projectId)
		.eq("wingId", wingId)
		.eq("unitNo", unitNo);
	if (data) return data;
	else throw error;
}

//*Collaterals
async function getAllProjectsCollateral(projectId, searchValue, filterBy, dateBy, selectedFolderId) {
	let query = supabase.from("ProjectCollaterals").select("*", { count: "exact" }).eq("projectId", projectId);

	if (searchValue) {
		query = query.ilike("fileName", "%" + searchValue + "%");
	}

	if (filterBy) {
		if (filterBy === "Folder") {
			query = query.eq("fileType", "folder");
		} else {
			query = query.eq("fileType", filterBy);
		}
	}

	if (dateBy?.[0]?.value !== "" && dateBy?.[1]?.value !== "" && dateBy !== undefined) {
		query = query.gte("last_updated_at", dateBy?.[0]?.value).lte("last_updated_at", dateBy?.[1]?.value);
	}

	if (selectedFolderId !== null && selectedFolderId !== undefined) {
		query = query.eq("parentId", selectedFolderId);
	}

	if (selectedFolderId === null) {
		query = query.is("parentId", null);
	}

	const { data, error, count } = await query;
	if (data) return { data, count };
	else throw error;
}

async function AddProjectsCollateral(obj) {
	let query = supabase.from("ProjectCollaterals").insert(obj);
	const { data, error, count } = await query;
	if (data) return { data, count };
	else throw error;
}

async function UpdateProjectsCollateral(Url, projectId, projectCollateralId) {
	let query = supabase
		.from("ProjectCollaterals")
		.Update({
			collateralUrl: Url,
		})
		.eq("projectId", projectId)
		.eq("projectCollateralId", projectCollateralId);
	const { data, error, count } = await query;
	if (data) return { data, count };
	else throw error;
}

async function updateParkingInventory(obj) {
	let query = supabase
		.from("ParkingInventory")
		.update({
			parkingHeight: obj?.parkingHeight,
			parkingBreadth: obj?.parkingBreadth,
			parkingLength: obj.parkingLength,
			description: obj?.description
		})
		.eq("parkingInventoryId", obj?.parkingInventoryId);
	const { data, error, count } = await query;
	if (data) return { data, count };
	else throw error;
}

async function UpdateWingSettings(value) {
	let query = supabase
		.from("Wings")
		.update({
			displayName: value?.displayName,
			termsAndCondition: value?.termsAndCondition,
			CRMHeadName: value?.crmHeadName,
			CRMHeadEmail: value?.crmHeadEmail,
			checkVirtualAccount: value?.checkVirtualAccount,
			logoUrl: value?.logoUrl
		})
		.eq("wingId", value?.wingId);

	const { data, error, count } = await query;
	if (data) return { data, count };
	else throw error;
}

// NEW (Cost Sheet Format Redesign, Phase 3): uploads a wing logo image, same pattern as
// uploadDigitCostBannerImg, but returns the storage key instead of writing it to the DB itself —
// WingSettings.jsx saves it together with the wing's other fields in one UpdateWingSettings call.
async function uploadWingLogo(obj, wingId) {
	return supabase.storage
		.from("wingLogos")
		.upload(`${wingId}/${obj.name}`, obj, { upsert: true })
		.then((res) => {
			if (res.data) return res.data.Key;
			throw res.error;
		});
}

async function UploadCollaterals(obj, id) {
	let query = supabase.storage.from("projectcollaterals").upload(`${id}/${obj.name}`, obj);
	const { data, error } = await query;
	if (data) return { data };
	else throw error;
}

async function AddProjectCollaterals(obj) {
	let query = supabase.from("ProjectCollaterals").insert(obj);
	const { data, error } = await query;
	if (data) return { data };
	else throw error;
}

async function AddProjectCollateralWithCp(obj) {
	let query = supabase.from("ProjectCollateralCpRelations").insert(obj);
	const { data, error } = await query;
	if (data) return { data };
	else throw error;
}

async function getProjectCollateralWithCpList() {
	const { data, error } = await supabase.from("ProjectCollateralCpRelations").select("*");
	if (data) return data;
	else throw error;
}

async function getProjectCollateralWithSalesList() {
	const { data, error } = await supabase.from("ProjectCollateralSalesRelations").select("*");
	if (data) return data;
	else throw error;
}

async function getProjectCollateralWithId(id, name) {
	const { data, error } = await supabase.from("ProjectCollaterals").select("*").eq("projectId", id).eq("fileName", name);
	if (data) return data;
	else throw error;
}

async function AddProjectCollateralWithSales(obj) {
	let query = supabase.from("ProjectCollateralSalesRelations").insert(obj);
	const { data, error } = await query;
	if (data) return { data };
	else throw error;
}

async function getProjectCollateralWithCp(id) {
	let query = supabase.from("ProjectCollateralCpRelations").select("*", { count: "exact" }).eq("id", id);
	const { data, error } = await query;
	if (data) return { data };
	else throw error;
}

async function RemoveCollateralFromTable(projectCollateralId) {
	let query = supabase.from("ProjectCollaterals").delete().eq("projectCollateralId", projectCollateralId);
	const { data, error } = await query;
	if (data) return data;
	else throw error;
}

async function deleteCollateralFromStorage(fileName) {
	const { data, error } = await supabase.storage.from("projectcollaterals").remove([fileName]);
	if (data) return data;
	else throw error;
}

async function RemoveCPFromCollateralRelations(id) {
	let query = supabase.from("ProjectCollateralCpRelations").delete().eq("id", id);
	const { data, error } = await query;
	if (data) return data;
	else throw error;
}

//*Price-List
async function getProjectPricingByProjectId(projectId, from, to) {
	let query = supabase.from("ProjectPricing").select("* , wingId(*)", { count: "exact" }).eq("projectId", projectId).range(from, to);
	const { data, error, count } = await query;
	if (data) return { data, count };
	else throw error;
}

async function getBasePricingByProjectId(projectId) {
	let query = supabase.from("ProjectPricing").select("*", { count: "exact" }).eq("projectId", projectId);
	const { data, error, count } = await query;
	if (data) return { data, count };
	else throw error;
}
async function getDefaultBasePricingByProjectId(projectId) {
	let query = supabase
		.from("ProjectPricing")
		.select("*", { count: "exact" })
		.eq("projectId", projectId)
		.is("startDateTime", null)
		.is("endDateTime", null);
	const { data, error, count } = await query;
	if (data) return { data, count };
	else throw error;
}

async function getParkingInventory(projectId) {
	let query = supabase
		.from("ParkingInventory")
		.select("* ,parkingTypeId(*)", { count: "exact" })
		.eq("projectId", projectId)
	const { data, error, count } = await query;
	if (data) return { data, count };
	else throw error;
}

async function insertIntoParkingInventory(obj) {
	let query = supabase.from("ParkingInventory").insert(obj);
	const { data, error, count } = await query;
	if (data) return { data, count };
	else throw error;
}

async function getParkingTypesFromInventory(projectId) {
	let query = supabase
		.from("ParkingInventory")
		.select("* , parkingTypeId(*) , parkingStatusId(*)", { count: "exact" })
		.eq("projectId", projectId)
	const { data, error, count } = await query;
	if (data) return { data, count };
	else throw error;
}

async function getParkingTypes() {
	let query = supabase
		.from("ParkingTypes")
		.select("*", { count: "exact" })
	const { data, error, count } = await query;
	if (data) return { data, count };
	else throw error;
}

// CRM2 M5-F4 (M5.11): price (and size) of an AVAILABLE slot of a CRM 2.0 project; an allotted slot never changes price
async function updateParkingInventoryPrice(obj) {
	const { data, error, count } = await supabase
		.from("ParkingInventory")
		.update({
			parkingCost: Number(obj?.parkingCost) || 0,
			parkingHeight: obj?.parkingHeight,
			parkingBreadth: obj?.parkingBreadth,
			parkingLength: obj?.parkingLength,
			description: obj?.description,
			last_updated_at: Date.now(),
		})
		.eq("parkingInventoryId", obj?.parkingInventoryId)
		.eq("parkingStatusId", 0)
		.select("parkingInventoryId");
	if (error) throw error;
	if (!data?.length) console.warn("[crm2][updateParkingInventoryPrice] slot not available any more, price kept", { parkingInventoryId: obj?.parkingInventoryId });
	return { data, count };
}
async function checkParkingInventory(parkingNumber, projectId) {
	let query = supabase
		.from("ParkingInventory")
		.select("* , parkingStatusId(*)", { count: "exact" })
		.eq("parkingNumber", parkingNumber)
		.eq("projectId", projectId)
	const { data, error, count } = await query;
	if (data) return { data, count };
	else throw error;
}
async function getDefaultBasePricing(projectId, wingId) {
	let query = supabase
		.from("ProjectPricing")
		.select("*")
		.eq("projectId", projectId)
		.eq("wingId", wingId)
		.is("startDateTime", null)
		.is("endDateTime", null);
	const { data, error, count } = await query;
	if (data) return { data, count };
	else throw error;
}

async function CheckPricingDefault(projectId, wingId, startDate, endDate) {
	let query = supabase.from("ProjectPricing").select("*", { count: "exact" }).eq("projectId", projectId).eq("wingId", wingId);
	const { data, error, count } = await query;
	if (data) return { data, count };
	else throw error;
}

async function ShowBasePrice(projectId, wingId) {
	let query = supabase.from("ProjectPricing").select("*", { count: "exact" }).eq("projectId", projectId).eq("wingId", wingId);
	const { data, error, count } = await query;
	if (data) return { data, count };
	else throw error;
}

async function CheckProjectPricingDetails(projectId, wingId, startDateTime, endDateTime) {
	let query = supabase
		.rpc("getprojectpricing", {
			startdate: startDateTime,
			enddate: endDateTime,
		})
		.select("*", { count: "exact" })
		.eq("projectId", projectId)
		.eq("wingId", wingId);
	const { data, error, count } = await query;
	if (data) return { data, count };
	else throw error;
}

async function AddProjectPricing(obj) {
	let query = supabase.from("ProjectPricing").insert(obj);
	const { data, error, count } = await query;
	if (data) return { data, count };
	else throw error;
}

async function UpdateProjectPricing(obj, projectPricingId) {
	let query = supabase.from("ProjectPricing").update(obj).eq("projectPricingId", projectPricingId);
	const { data, error, count } = await query;
	if (data) return { data, count };
	else throw error;
}

async function getProjectDataByProjectId(projectId) {
	let query = supabase.from("Inventory").select("*", { count: "exact" }).eq("projectId", projectId);
	const { data, error, count } = await query;
	if (data) return { data, count };
	else throw error;
}

async function getAllChannelPartners() {
	let query = supabase.from("CpContactPerson").select("* , CP(*)", { count: "exact" });
	const { data, error, count } = await query;
	if (data) return { data, count };
	else throw error;
}

async function RemoveBasePriceFromTable(projectPricingId) {
	let query = supabase.from("ProjectPricing").delete().eq("projectPricingId", projectPricingId);
	const { data, error } = await query;
	if (data) return data;
	else throw error;
}

//*Payment-Plan
async function AddPaymentPlansToData(obj) {
	let query = supabase.from("PaymentPlans").insert(obj);
	const { data, error, count } = await query;
	if (data) return { data, count };
	else throw error;
}

async function UpdatePaymentPlansToData(obj, paymentPlanId) {
	let query = supabase.from("PaymentPlans").update(obj).eq("paymentPlanId", paymentPlanId);
	const { data, error, count } = await query;
	if (data) return { data, count };
	else throw error;
}

async function getPaymentPlansFromDb(projectId, from, to) {
	let query = supabase
		.from("PaymentPlans")
		.select("* , wingId(*) , inventoryTypeId(*)", { count: "exact" })
		.eq("projectId", projectId)
		.range(from, to);
	const { data, error, count } = await query;
	if (data) return { data, count };
	else throw error;
}

async function CheckPaymentPlansDetails(projectId, WingName, UnitType, titleForMatch, paymentPlanId) {
	let query = supabase
		.from("PaymentPlans")
		.select("*", { count: "exact" })
		.eq("projectId", projectId)
		.eq("wingId", WingName)
		.eq("displayUnitType", UnitType)
		.eq("titleForMatch", titleForMatch)

	if (paymentPlanId) {
		query = query.neq("paymentPlanId", paymentPlanId)
	}
	const { data, error, count } = await query;
	if (data) return { data, count };
	else throw error;
}

async function RemovePaymentPlanFromTable(paymentPlanId) {
	let query = supabase.from("PaymentPlans").delete().eq("paymentPlanId", paymentPlanId);
	const { data, error } = await query;
	if (data) return data;
	else throw error;
}

async function RemovePaymentPlanFromLaunch(paymentPlanId) {
	let query = supabase.from("LaunchPaymentPlanRelations").delete().eq("paymentPlanId", paymentPlanId);
	const { data, error } = await query;
	if (data) return data;
	else throw error;
}

async function addProjectToDb(obj) {
	const { data, error } = await supabase.from("Projects").insert(obj).select();
	if (data) return data;
	else throw error;
}

async function addWing(obj) {
	const { data, error } = await supabase.from("Wings").insert(obj).select();
	if (data) return data;
	else throw error;
}

async function addInventory(obj) {
	const { data, error } = await supabase.from("Inventory").insert(obj).select();
	if (data) return data;
	else throw error;
}

async function addInventoryLogs(obj) {
	const { data, error } = await supabase.from("InventoryLogs").insert({
		unitId: obj.unitId,
		status: "added",
		projectId: obj.projectId,
		userId: JSON.parse(localStorage.getItem("user")).userId,
	});
	if (data) return data;
	else throw error;
}

async function addBookingAmounts(obj) {
	const { data, error } = await supabase.from("BookingAmounts").insert(obj);
	if (data) return data;
	else throw error;
}

async function addAdditionalConfig(obj) {
	const { data, error } = await supabase.from("projectAdditionalConfiguration").insert(obj);
	if (data) return data;
	else throw error;
}

async function getBookingAmounts(projectId) {
	const { data, error } = await supabase.from("BookingAmounts").select("* , wingId(*) , inventoryTypeId(*)").eq("projectId", projectId);
	if (data) return data;
	else throw error;
}

async function getAdditionalConfig(projectId) {
	const { data, error } = await supabase
		.from("projectAdditionalConfiguration")
		.select("* , wingId(*) , inventoryTypeId(*)")
		.eq("projectId", projectId);
	if (data) return data;
	else throw error;
}

async function CheckBookingAmounts(projectId, wingId, inventoryTypeId) {
	const { data, error } = await supabase
		.from("BookingAmounts")
		.select("* , wingId(*) , inventoryTypeId(*)")
		.eq("projectId", projectId)
		.eq("wingId", wingId)
		.eq("inventoryTypeId", inventoryTypeId);
	if (data) return data;
	else throw error;
}

async function CheckAdditionalConfig(projectId, wingId, DisplayUnitTypeName, inventoryTypeId) {
	const { data, error } = await supabase
		.from("projectAdditionalConfiguration")
		.select("* , wingId(*) , inventoryTypeId(*)")
		.eq("projectId", projectId)
		.eq("wingId", wingId)
		.eq("displayUnitType", DisplayUnitTypeName)
		.eq("inventoryTypeId", inventoryTypeId);
	if (data) return data;
	else throw error;
}

async function UpdateBookingAmounts(projectId, wingId, inventoryTypeId, obj) {
	const { data, error } = await supabase
		.from("BookingAmounts")
		.update(obj)
		.eq("projectId", projectId)
		.eq("wingId", wingId)
		.eq("inventoryTypeId", inventoryTypeId);
	if (data) return data;
	else throw error;
}

async function UpdateAdditionalConfig(projectId, wingId, displayUnitType, inventoryTypeId, obj) {
	const { data, error } = await supabase
		.from("projectAdditionalConfiguration")
		.update(obj)
		.eq("projectId", projectId)
		.eq("wingId", wingId)
		.eq("displayUnitType", displayUnitType)
		.eq("inventoryTypeId", inventoryTypeId);
	if (data) return data;
	else throw error;
}

async function updateProject(obj) {
	obj.last_updated_at = new Date().getTime();
	const { data, error } = await supabase.from("Projects").update(obj).eq("projectId", obj.projectId);
	if (data) return data;
	else throw error;
}

async function addProjectLogsForSdrPercent(obj) {
	const { data, error } = await supabase
		.from('ProjectLogs')
		.insert([{
			...obj
		}])
	if (data) return data;
	else throw error;
}

async function getProjectById(buId, type) {
	let query = supabase.from("Projects").select("*", { count: "exact" }).eq("buId", buId).eq("type", type).eq("isVJ", true);
	const { data, error, count } = await query;
	if (data) return { data, count };
	else throw error;
}

async function getProjectByProjectId(projectId) {
	let query = supabase.from("Projects").select("*", { count: "exact" }).eq("projectId", projectId);
	const { data, error, count } = await query;
	if (data) return { data, count };
	else throw error;
}

async function getJdProjectsByParentId(salesParentProjectId) {
	const { data, error } = await supabase
		.from("Projects")
		.select("*")
		.eq("salesParentProjectId", salesParentProjectId)
		.eq("isVJ", false);
	if (data) return data;
	else throw error;
}

function UploadEmailDoc(fileObject, fileName) {
	return new Promise(async (resolve, reject) => {
		let uploadResponse = await supabase.storage.from("projectagreements").upload(fileName, fileObject, { upsert: true });
		if (uploadResponse.data) {
			console.log("uploadResponse.data => ", uploadResponse.data);
			const _url = supabase.storage.from("projectagreements").getPublicUrl(fileName).data.publicURL;
			resolve({ success: true, url: _url });
		} else {
			resolve({ success: false, error: uploadResponse?.error });
		}
	});
}

async function deleteUploadedEmailDoc(projectName, docItem) {
	const { data, error } = await supabase.storage
		.from('projectagreements')
		.remove([`${projectName}/${docItem?.name}`]);

	if (data) return { data };
	else throw error;
}

async function getPaymentPlansPriceFromDb(projectId) {
	let query = supabase.from('PaymentPlanPrice').select('*', { count: 'exact' }).eq('projectId', projectId)
	const { data, error, count } = await query;
	if (data) return { data, count };
	else throw error;
}
async function updatePaymentPlanPrice(obj) {
	obj.last_updated_at = new Date().getTime();
	const { data, error } = await supabase
		.from("PaymentPlanPrice")
		.update(obj)
		.eq("paymentPlanPriceId", obj.paymentPlanPriceId);
	if (data) return data;
	else throw error;
}
async function insertPaymentPlanPrice(obj) {
	const { data, error } = await supabase
		.from("PaymentPlanPrice")
		.insert(obj)
	if (data) return data;
	else throw error;
}

async function getPaymentPlansPriceFromServer(id, unitId) {
	let query = supabase.from('PaymentPlanPrice').select('*', { count: 'exact' }).eq('paymentPlanId', id).eq("unitId", unitId)
	const { data, error, count } = await query;
	if (data) return { data, count };
	else throw error;
}

export {
	addProjectToDb,
	getProjectById,
	addInventoryLogs,
	addWing,
	updateProject,
	addBookingAmounts,
	CheckBookingAmounts,
	addInventory,
	getAllProjects,
	getBookingAmounts,
	UpdateBookingAmounts,
	getAllProjectsCollateral,
	getProjectPricingByProjectId,
	AddProjectPricing,
	getProjectDataByProjectId,
	getAllChannelPartners,
	getBasePricingByProjectId,
	AddProjectsCollateral,
	UploadCollaterals,
	AddPaymentPlansToData,
	getPaymentPlansFromDb,
	CheckPaymentPlansDetails,
	CheckProjectPricingDetails,
	AddProjectCollaterals,
	AddProjectCollateralWithCp,
	RemoveBasePriceFromTable,
	RemovePaymentPlanFromTable,
	RemoveCollateralFromTable,
	RemoveCPFromCollateralRelations,
	getProjectCollateralWithCp,
	uploadDigitCostBannerImg,
	CheckPricingDefault,
	deleteCollateralFromStorage,
	UpdateProjectsCollateral,
	ShowBasePrice,
	RemovePaymentPlanFromLaunch,
	UpdatePaymentPlansToData,
	updateFlagsToProjectTable,
	UpdateProjectPricing,
	getAdditionalConfig,
	CheckAdditionalConfig,
	addAdditionalConfig,
	UpdateAdditionalConfig,
	UpdateUnitInfo,
	getDefaultBasePricing,
	getDefaultBasePricingByProjectId,
	UpdateWingSettings,
	uploadWingLogo,
	UpdateProjectTnC,
	getProjectByProjectId,
	getUnitDataByProjectId,
	AddProjectCollateralWithSales,
	getProjectCollateralWithCpList,
	getProjectCollateralWithSalesList,
	getProjectCollateralWithId,
	UploadEmailDoc,
	addProjectLogsForSdrPercent,
	deleteUploadedEmailDoc,
	getParkingInventory,
	getParkingTypes,
	insertIntoParkingInventory,
	checkParkingInventory,
	updateParkingInventoryPrice,
	getParkingTypesFromInventory,
	getPaymentPlansPriceFromDb,
	updatePaymentPlanPrice,
	insertPaymentPlanPrice,
	getPaymentPlansPriceFromServer,
	updateParkingInventory,
	getJdProjectsByParentId,
};
